import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const VideoSidebarContext = createContext();

export const VideoSidebarProvider = ({ children }) => {
  const [sidebarData, setSidebarData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openSidebar = useCallback((data) => {
    setSidebarData(data);
    setIsOpen(true);
  }, []);

  const closeSidebar = useCallback(() => {
    setIsOpen(false);
    setSidebarData(null);
  }, []);

  const toggleSidebar = useCallback(
    (data) => {
      if (isOpen) {
        closeSidebar();
      } else {
        openSidebar(data);
      }
    },
    [isOpen, openSidebar, closeSidebar],
  );

  const value = useMemo(
    () => ({
      sidebarData,
      isOpen,
      openSidebar,
      closeSidebar,
      toggleSidebar,
    }),
    [sidebarData, isOpen, openSidebar, closeSidebar, toggleSidebar],
  );

  return (
    <VideoSidebarContext.Provider value={value}>
      {children}
    </VideoSidebarContext.Provider>
  );
};

export const useVideoSidebar = () => {
  const context = useContext(VideoSidebarContext);
  if (!context) {
    throw new Error('useVideoSidebar must be used within a VideoSidebarProvider');
  }
  return context;
};
